// @flow

import { observable } from 'mobx';
import HttpBackend from '../Services/HttpBackend'
import PageResult from './PageResult'

export default class Bestimmung {
  @observable id: string;
  @observable name: string;
  
  constructor(json?: any) {
    if(json) {
      Object.assign(this, json);
    }
  }
  
  static async create(data: any): Promise<Bestimmung> {
    const res = await HttpBackend.post('/api/bestimmung', data);
    if (res.ok) {
      return new Bestimmung(res.data);
    }
    throw new Error(res.problem);
  }
  
  static async list(params?: any = {}): Promise<PageResult<Bestimmung>> {
    const res = await HttpBackend.get(`/api/bestimmung`, params);
    if(res.ok) {
      res.data.data = res.data.data.map(j => new Bestimmung(j));
      return new PageResult(res.data);
    }
    throw new Error(res.error);
  }
  
  static async find(params?: any = {}): Promise<PageResult<Bestimmung>> {
    return await this.list(params);
  }
}


// WEBPACK FOOTER //
// ./src/App/Model/Bestimmung.js